// Lightweight analytics: captures UTM, fires events to backend, and pushes to dataLayer (Meta/GA-ready).
import axios from "axios";

// Empty -> relative path (Cloudflare Pages Functions on same origin)
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

export function captureUTM() {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const incoming = {};
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) incoming[k] = v;
  });
  if (Object.keys(incoming).length) {
    try {
      localStorage.setItem("havo_utm", JSON.stringify(incoming));
    } catch (_) {}
    return incoming;
  }
  try {
    const stored = localStorage.getItem("havo_utm");
    return stored ? JSON.parse(stored) : {};
  } catch (_) {
    return {};
  }
}

export function trackEvent(event, payload = {}) {
  const utm = captureUTM();
  const body = { event, ...payload, extra: { ...(payload.extra || {}), utm } };
  // Meta Pixel + GA dataLayer
  try {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, ...payload, utm });
      if (window.fbq) window.fbq("trackCustom", event, { ...payload, utm });
    }
  } catch (_) {}
  // Fire and forget to backend (relative path works on same origin)
  if (BACKEND !== undefined) {
    axios.post(`${BACKEND}/api/events`, body).catch(() => {});
  }
}

export function trackCall(source, extra = {}) {
  trackEvent("ClickCall", { source, ...extra });
}
